import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: '17rem'
  },

  button: {
    margin: '1rem 0',
    width: 'fit-content',
    padding: '5px 22px',
    fontSize: theme.size.base
  },

  filter: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none',

    '& .icon': {
      marginRight: '0.25rem',
      fontSize: theme.size.sm,
      color: theme.palette.primary.main,

      '& svg': {
        display: 'block'
      }
    },

    '& .text': {
      fontSize: theme.size.sm,
      color: theme.palette.textLight
    }
  },

  children: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  }
}))

export default useStyles
